module.exports = __webpack_public_path__ + "static/media/5.8cc05d52.png";